module.exports = __webpack_public_path__ + "static/media/118.23b838f2.svg";